import React from "react";
import { getValue } from "../../../utils/object.utils";
import { AvatarSize, UserAvatar } from "../../UserAvatar/UserAvatar";
import { USER_GENDER_TITLE } from "../../../Constants/Titles/user.title";
import { KeyValueList } from "../../KeyValueList";
import { BadgeType, CardBadge } from "../../Badge/CardBadge";
import { RESULT_STATUS } from "../../../Constants/Enums/Results.enum";
import { RESULT_STATUS_TITLE } from "../../../Constants/Titles/result.title";
import { StudentResultInterface } from "../../../Constants/Interfaces/bodyInterface/studentResult.interface";

interface Props {
  studentData: StudentResultInterface;
}

export const StudentInfoItem = ({ studentData }: Props) => {
  const studentName = studentData.full_name;

  const avatar = getValue(studentData, "avatar", "");
  const gender = USER_GENDER_TITLE[getValue(studentData, "gender", "")];
  const rollNo = getValue(studentData, "roll_no", "N/A");
  const percentage = getValue(studentData, "percentage", "N/A");
  const position = getValue(studentData, "position", "N/A");

  const resultStatus = getValue(
    studentData,
    "result_status",
    RESULT_STATUS.PENDING
  );

  const badgeType =
    resultStatus === RESULT_STATUS.PENDING
      ? BadgeType.danger
      : resultStatus === RESULT_STATUS.IN_PROGRESS
      ? BadgeType.warning
      : resultStatus === RESULT_STATUS.COMPLETED
      ? BadgeType.success
      : BadgeType.danger;

  const badgeText = RESULT_STATUS_TITLE[resultStatus];

  return (
    <div
      className="flex flex-col gap-4"
      style={{
        position: "relative",
      }}
    >
      <div className="Header flex items-center gap-4 mt-6">
        <UserAvatar
          image={avatar}
          size={AvatarSize.xm}
          userName={studentName}
        />
        {studentName}
      </div>
      <div className="flex flex-row justify-around pl-2">
        <KeyValueList
          lists={[
            { key: "Roll no", value: rollNo },
            { key: "Gender", value: gender },
          ]}
        />
        <KeyValueList
          lists={[
            { key: "Percentage", value: `${percentage}` },
            { key: "Position", value: position },
          ]}
        />
      </div>
      <div
        style={{
          position: "absolute",
          top: -5,
          right: -10,
        }}
      >
        <CardBadge badgeText={badgeText} badgeType={badgeType} />
      </div>
    </div>
  );
};
